import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import s from "./EditService.module.scss";
import { Button, Col, Form, Row, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import Footer from "../../components/Footer/Footer";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { IServiceResponse } from "../../types";
import {
  getServiceDetails,
  getServicesList,
  updateService,
} from "../../redux/ServiceSlice";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

const EditService = () => {
  const [form] = useForm();
  const service = useSelector((state: RootState) => state.service.service);
  const dispatch: AppDispatch = useDispatch();
  const [changedValues, setChangedValues] = useState<IServiceResponse>();
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const brokers = useSelector(
    (state: RootState) => state.user.managerEmployeesList,
  );

  useEffect(() => {
    if (!service) return;
    form.setFieldsValue({
      service_name: service.service_name,
      broker: `${service.broker_name} - ${service.broker_email}`,
      price: service.price,
      comment: service.comment,
    });
  }, [service]);

  const editService = async (values: IServiceResponse) => {
    if (changedValues) {
      const data = new FormData();

      for (const [key, value] of Object.entries(changedValues)) {
        if (value !== undefined && value !== null) {
          data.append(key, value as any); // если файлы будут — отдельная проверка
        }
      }
      const res = await dispatch(
        updateService({ id: Number(params.id), formData: data }),
      );

      if (res.type === "services/updateService/fulfilled") {
        dispatch(getServiceDetails(Number(params.id)));
        toast.success("Вы обновили услугу");
        dispatch(getServicesList(1));
        setTimeout(() => {
          navigate("/services");
        }, 1000);
      }
    }
  };

  const onValuesChange = (
    changed: Partial<IServiceResponse>,
    allValues: IServiceResponse,
  ) => {
    Object.keys(changed).find((key) => {
      setChangedValues((prev: any) => ({ ...prev, ...changed }));
    });
  };

  return (
    <div className={s.createService}>
      <ToastContainer />
      <Header />
      <div className={s.content}>
        <Link to="/services" className={s.back}>
          <ArrowLeftOutlined className={s.left} /> {t("Назад")}
        </Link>
        <h2 className={s.h2}>{t("Редактировать услугу")}</h2>
        <div className={s.form}>
          <Form
            layout="vertical"
            className={"create_application"}
            form={form}
            onFinish={editService}
            onValuesChange={onValuesChange}
          >
            <Row>
              <Col span={12}>
                <Form.Item
                  name="service_name"
                  label={t("Услуга")}
                  rules={[
                    {
                      required: true,
                      message: t("Укажите услугу"),
                    },
                  ]}
                >
                  <input
                    placeholder={t("Укажите услуга")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="price"
                  label={t("Цена, USD")}
                  rules={[
                    {
                      required: true,
                      message: t("Укажите цену"),
                    },
                  ]}
                >
                  <input placeholder={t("Укажите цену")} className={s.input} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="broker"
                  label={t("Компания/Пользователь")}
                  rules={[
                    {
                      required: true,
                      message: t("Укажите компанию"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("Выберите брокера")}
                    options={brokers?.results?.map((it) => ({
                      value: it?.id,
                      label: `${it.company_name} - ${it.email}`,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="comment" label={t("Комментарий")}>
                  <textarea
                    placeholder={t("Комментарий")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className={s.btns}>
              <Button className={s.btn} htmlType="submit">
                {t("Редактировать услугу")}
              </Button>
            </Row>
          </Form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EditService;
